import { render, staticRenderFns } from "./SingleProccessInNew.vue?vue&type=template&id=1a05e222&"
import script from "./SingleProccessInNew.vue?vue&type=script&lang=js&"
export * from "./SingleProccessInNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports